export enum PaymentState {
  NotCharged = 0,

  // The payment was created
  Created = 1,

  // The payment was done
  Paid = 2,

  // The payment has failed
  Failed = 3,

  // The payment was canceled
  Canceled = 4,
}
